import { GetStartedSectionById } from "../../queries/entries/GetStartedSectionById";
import { ResultOf } from "gql.tada";
import { GetStartedForm } from "./GetStartedSection/GetStartedForm";
import { BackgroundBlob } from "../shared/BackgroundBlob";
import { useState } from "react";
import { GetStartedSubmission } from "./GetStartedSection/GetStartedSubmission";
import { MarkdownLite } from "../shared/MarkdownLite";

export const GetStartedSection = ({
  entry: { getStartedSection: entry },
}: {
  entry: ResultOf<typeof GetStartedSectionById>;
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  if (!entry) return;

  if (isSubmitted) return <GetStartedSubmission entry={entry} />;

  return (
    <section className="mb-20 mt-20 relative">
      <BackgroundBlob />
      <div className="flex flex-col container-base dsk:grid-base">
        <div className="col-start-2 col-span-8">
          <div className="dsk:sticky top-16">
            <h1 className="text-heading-2">{entry?.title}</h1>
            <p className="text-body-regular my-10">
              <MarkdownLite>{entry?.description ?? ""}</MarkdownLite>
            </p>
          </div>
        </div>
        <GetStartedForm
          entry={entry}
          onSubmitSuccess={() => setIsSubmitted(true)}
          className="col-start-12 col-end-24"
        />
      </div>
    </section>
  );
};
